
import { AddonMode, ConfigurationItem, InitMessage, KeyDownMessage, MessageType, SnapshotLoadMessage, TokenRefreshMessage } from 'meet-addons-sdk';
import { toJS } from 'mobx';
import { AddonRuntimeInfo } from '../../domain/api/addons/AddonRuntimeInfo';
import configStore from '../../stores/ConfigStore';
import contextStore from '../../stores/ContextStore';

class AddonMessanger {

    public sendTokenRefreshMessage(addonRuntimeInfo: AddonRuntimeInfo) {

        const tokenRefreshMessage = new TokenRefreshMessage();
        tokenRefreshMessage.token = addonRuntimeInfo.token;
        
        this.sendMessage(JSON.stringify(tokenRefreshMessage), addonRuntimeInfo);
    }

    public sendInitMessage(addonIdentifier: string, mode: AddonMode) {

        const {chromeState, meetingState, participantInfos} = contextStore!;

        const addonConfig = contextStore.addonsInfo.find(p => p.identifier === addonIdentifier);
        if (!addonConfig) {
          // TODO:  m1 - report to TX?
          return;
        }

        const participants = toJS(participantInfos.filter(p => p.addonIdentifier === addonConfig.identifier))

        const configuration: ConfigurationItem[] = [];
        const configs = JSON.parse(addonConfig.configuration);
        for (var config in configs) {
            configuration.push({
                key: config,
                value: configs[config]
            })
        }

        const message: InitMessage = {
            chromeState,
            configuration,
            host: {
                authHost: configStore.hosts.auth,
                origin: window.location.origin,
            },
            mode:mode,
            participants,
            principal: {
                addonIdentifier: addonConfig.identifier,
                avatarUrl: configStore.me!.avatarUrl,
                color: configStore.me!.color,
                displayName: `${configStore.me!.firstName} ${configStore.me!.familyName}`,
                isGuest: configStore.me!.isGuest,
                sessionId: addonConfig.sessionId,
                sessionUserId: addonConfig.sessionUserId,
                sessionUserRole: addonConfig.sessionUserRole,
                tenant: addonConfig.tenant,
                theme: configStore.me!.theme,
                token: addonConfig.token,
                
            },
            settings: addonConfig.settings,
            state: meetingState!,
            type: MessageType.INIT,
        };

        this.sendMessage(JSON.stringify(message), addonConfig);
    }

    /**
     * Sending the request to all the currently loaded addons to load the snapshot.
     *
     * @param {string} snapshotId
     * @memberof AddonMessanger
     */
    public sendKeyDownMessageToAddons(keyDownMessage: KeyDownMessage) {
        
        contextStore.addonsInfo.forEach(p => {
            const addonConfig = contextStore.addonsInfo.find(ai => ai.identifier === p.identifier);
            if (!addonConfig) {
              // TODO:  m1 - report to TX?
              return;
            }

            this.sendMessage(JSON.stringify(keyDownMessage), addonConfig);
        })
    }

    /**
     * Sending the request to all the currently loaded addons to load the snapshot.
     *
     * @param {string} snapshotId
     * @memberof AddonMessanger
     */
    public sendSnapshotLoadMessageToAddons(snapshotId: string) {
        
        contextStore.addonsInfo.forEach(p => {
            const addonConfig = contextStore.addonsInfo.find(ai => ai.identifier === p.identifier);
            if (!addonConfig) {
              // TODO:  m1 - report to TX?
              return;
            }

            const message: SnapshotLoadMessage = new SnapshotLoadMessage();
            message.snapshotId = snapshotId;
            this.sendMessage(JSON.stringify(message), addonConfig);
        })
    }

    private sendMessage = (message: string, addonConfig: AddonRuntimeInfo) => {
      // TODO:  m1 - report to TX this KPI?

      const frameId = `addon-${addonConfig.identifier}`;

      const iframe = document.getElementById(frameId) as HTMLIFrameElement;
      if (!iframe || !iframe.contentWindow) {
          // TODO:  m1 - report to TX?
          return;
      }


      const originHost = this.getOriginHost(addonConfig);
      iframe.contentWindow.postMessage(message, originHost);
    }
    
    private getOriginHost = (addonConfig: AddonRuntimeInfo) => {
      const addonHostUrl = new URL(addonConfig.host.url);
      let addonHost = `${addonHostUrl.protocol}//${addonHostUrl.hostname}`;

      if (addonHostUrl.port && addonHostUrl.port !== "80" && addonHostUrl.port !== "443" ) {
          addonHost += `:${addonHostUrl.port}`;
      }

      return addonHost;
    }


}

export default new AddonMessanger();